import { render, staticRenderFns } from "./Recruit.vue?vue&type=template&id=41ec96b8"
var script = {}
import style0 from "./Recruit.vue?vue&type=style&index=0&id=41ec96b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports